export default __webpack_public_path__ + "static/media/september.5cc224b9.jpg";